import { $, addAction, doAction } from '@situation/setdesign.util';
import EventCardData from './EventCardData';

/* global moment */
class EventList {
    constructor(group) {
        this.group = group;
        this.selected = [];
        this.$list = $(`[data-filter-control="${group}"]`).find('[data-filter-id]');

        this.getAll = ($list) => {
            const performances = [];
            $list.each((_index, element) => {
                const $item = $(element);
                const cardData = new EventCardData($item);
                const times = $item.find('[data-performances]').data('performances');
                $.each(times, (_timeIndex, time) => {
                    performances.push($.extend({ start: moment(time) }, cardData));
                });
            });

            performances.sort((a, b) => (a.start.isAfter(b.start) ? 1 : -1));
            return performances;
        };

        this.all = this.getAll(this.$list);
        this.filtered = this.all;
        this.month = false;
        addAction(`filters/values/${this.group}`, this.filter, 20, this);
        this.filter();
    }

    filter(filters) {
        this.month = false;

        if ($.isPlainObject(filters)) {
            const key = Object.keys(filters).filter((filter) => filter.indexOf('month') > -1);
            if (key.length && filters[key[0]]) {
                this.month = moment(filters[key[0]]);
            }
        }

        this.selected = this.$list
            .not('.filters--hide')
            .map((_index, element) => $(element).data('filterId'))
            .get();

        const checkMonth = Boolean(this.month);
        this.filtered = this.all.filter(
            (item) => this.selected.indexOf(item.id) >= 0 && (!checkMonth || this.month.isSame(item.start, 'month')),
        );

        doAction(this.filtered.length ? 'calendar/refresh' : 'calendar/noResults');
    }

    get() {
        return this.filtered;
    }

    range() {
        return {
            start: moment(this.filtered[0].start).startOf('month'),
            end: moment(this.filtered[this.filtered.length - 1].start).endOf('month'),
        };
    }
}

export default EventList;
